import icons from "url:../../img/icons.svg";
import View from "./view";
class PaginationView extends View
{
  constructor()
  {
    super(document.querySelector(".pagination"));
  }
  _generateMarkup()
  {
    const currentPage = this._data.currentPage;
    const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
    
    // At Page 1 & other Pages
    if (currentPage === 1 && numPages > 1)
    {
      return `
      <button class="btn--inline pagination__btn--next pagination-btn" data-to-page="${currentPage + 1}">
        <span>Page ${currentPage + 1}</span>
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-right"></use>
        </svg>
      </button>
      `;
    }
    
    // At Last Page
    if (currentPage === numPages && numPages>1)
    {
      return `
      <button class="btn--inline pagination__btn--prev pagination-btn" data-to-page="${currentPage - 1}">
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-left"></use>
        </svg>
        <span>Page ${currentPage - 1}</span>
      </button>
      `;
    }
    // At some page
    if (currentPage < numPages)
    {
      return `
      <button class="btn--inline pagination__btn--next pagination-btn" data-to-page="${currentPage + 1}">
        <span>Page ${currentPage + 1}</span>
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-right"></use>
        </svg>
      </button>
      <button class="btn--inline pagination__btn--prev pagination-btn" data-to-page="${currentPage - 1}">
        <svg class="search__icon">
          <use href="${icons}#icon-arrow-left"></use>
        </svg>
        <span>Page ${currentPage - 1}</span>
      </button>
      `;
    }
    
    // At Page 1 & NO other Pages
    return "At Page 1 and No more Pages";
  }
  addHandlerChangePage(handler)
  {
    this._parentElement.addEventListener("click", function(e)
    {
      const btn = e.target.closest(".pagination-btn");
      if (!btn) return;
      const {toPage} = btn.dataset;
      handler(+toPage);
    })
  }
}
export default new PaginationView();